import React from 'react';
import { FaPhone } from 'react-icons/fa';

function FloatingContact() {
  return (
    <a
      href="tel:+421918495001"
      className="fixed bottom-6 right-6 z-50 bg-red-600 hover:bg-red-700 text-white rounded-full shadow-xl flex items-center gap-3 px-5 py-4 transition-all duration-200 hover:scale-105 group"
      aria-label="Zavolajte nám"
    >
      <FaPhone className="text-lg flex-shrink-0 animate-pulse group-hover:animate-none" />
      <span className="hidden sm:inline font-semibold text-sm whitespace-nowrap">
        Zavolajte nám
      </span>
    </a>
  );
}

export default FloatingContact;
